import styled from '@emotion/styled';
import { borderRadius, spacing } from 'presentations/views/styles';
import { memo } from 'react';

interface Props {
  color: string;
  className?: string;
}

const Component = memo((props: Props) => {
  return <Color color={props.color} className={props.className} />;
});

const Color = styled.span<{ color: string }>`
  display: inline-block;
  margin-right: ${spacing(8)};
  width: 8px;
  height: 8px;
  border-radius: ${borderRadius(4)};
  background-color: ${({ color }) => color};
`;

export default Component;
